"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _emotionTheming = require("emotion-theming");

var _recompose = require("recompose");

var _reactPopover = _interopRequireDefault(require("react-popover"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var abruptFadeDuration = 1;
var defaultNotchSize = 7;
var smallestTruthyFloatNumber = .01;

var _Popover = (
/*#__PURE__*/
0, _styledBase.default)(_reactPopover.default, {
  target: "etgulx20"
})(".Popover-body{background-color:white;box-shadow:", (0, _styledSystem.themeGet)('container.shadow.2'), ";border-radius:", (0, _styledSystem.themeGet)('container.radius.1'), "px;padding:", (0, _styledSystem.themeGet)('spacing.4'), "px;}.Popover-tipShape{fill:white;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

var _default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Popover'), (0, _recompose.defaultProps)({
  enterExitTransitionDurationMs: abruptFadeDuration,
  hasNotch: true
}), (0, _recompose.setPropTypes)({
  body: _propTypes.default.node.isRequired,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.arrayOf(_propTypes.default.node)]).isRequired,
  isOpen: _propTypes.default.bool.isRequired,
  place: _propTypes.default.string,
  enterExitTransitionDurationMs: _propTypes.default.number,
  onOuterAction: _propTypes.default.func,
  preferPlace: _propTypes.default.string,
  tipSize: _propTypes.default.number,
  hasNotch: _propTypes.default.bool
}), _emotionTheming.withTheme, (0, _recompose.withProps)(function (_ref) {
  var hasNotch = _ref.hasNotch,
      theme = _ref.theme;
  return {
    tipSize: hasNotch ? defaultNotchSize : smallestTruthyFloatNumber,
    offset: Number(hasNotch ? theme.spacing[2] : theme.spacing[3])
  };
}))(_Popover);

exports.default = _default;